import { manifests as conditionManifests } from './conditions/manifests.js';

export const manifests = [...conditionManifests];
